import { compose, createStore, applyMiddleware } from "redux";
import { createBrowserHistory } from "history";
import { createEpicMiddleware } from "redux-observable";
import { routerMiddleware } from "connected-react-router";
import rootEpic from "root/rootEpic";
import createRootReducer from "root/rootReducer";
import persistAuthData from "./auth/authMiddleware";

export const history = createBrowserHistory();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const epicMiddleware = createEpicMiddleware();

const configureStore = () => {
  const store = createStore(
    createRootReducer(history),
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history),
        epicMiddleware,
        persistAuthData,
      ),
    ),
  );

  if (module.hot) {
    module.hot.accept("root/rootReducer", () => {
      const createRootReducer = require("root/rootReducer").default;
      store.replaceReducer(createRootReducer(history));
    });
  }

  epicMiddleware.run(rootEpic);
  return store;
};

if (module.hot) {
  module.hot.accept("root/rootEpic", () => {
    const rootEpic = require("root/rootEpic").default;
    epicMiddleware.replaceEpic(rootEpic);
  });
}

export default configureStore;
